import React from 'react';
import { AxiosResponse } from 'axios';
import { Viewer } from '../../Common';
import { Dialog, DialogContent, DialogContentText, DialogTitle } from '../../dialog';
import { Button } from '../../formikFormInputs';
import { SnackbarContext } from '../../Snackbar/Context';
import { useAuth } from '../../../lib/useAuth';
import { privateApi } from '../../../lib/privateApi';
import { noop } from '../../../utils/commonUtils';
import { initFalse } from '../../../utils/constants';
import { SnackBarSeverity } from '../../../utils/enums';
import { externalServerUrl } from '../../../server/constants';


interface AgreementProps {
  onCancel: any | Function;
  onConfirm: any | Function;
  show: boolean;
}

interface DocSignData {
  envelopeId: string;
  envelopeUrl: string;
}


const Agreement = ({onCancel, onConfirm, show}: AgreementProps) => {
  const {user} = useAuth();
  const sb = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(initFalse);
  const [dsUrl, setDSUrl] = React.useState('');

  const loadAgreement = async () => {
    setLoading(!initFalse);

    const sellerAgreementUrl = 'docusign/seller/envelope';
    const pageUrl = `${externalServerUrl}/tyDSPopupClose`;
    const con = {params: {agentId: user.agent.id, pageUrl}};
    const res: AxiosResponse = await privateApi.get(sellerAgreementUrl, con)
      .then(res => res.data)
      .catch(err => {
        // TODO handle error
        sb.showMessage(err, SnackBarSeverity.Error);
        onCancel();
        throw err;
      });

    const docusignData: DocSignData = res.data;
    setDSUrl(docusignData.envelopeUrl);
    setLoading(initFalse);
  };
  const mountEvent = () => {
    loadAgreement().then();

    return noop;
  };

  const loadingMsg = 'Signing document is being prepared. This could take some time so please be patient and don\'t close this window.';


  React.useEffect(mountEvent, []);

  return (
    <Dialog
      aria-describedby="agreement-dialog"
      disableBackdropClick={!initFalse}
      disableEscapeKeyDown={!initFalse}
      fullWidth={!initFalse}
      keepMounted={!initFalse}
      maxWidth="md"
      onClose={onCancel}
      open={show}
    >
      <DialogTitle>Approved Agent Selling Agreement</DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="agreement-dialog">
          <Viewer loading={loading} loadingMessage={loadingMsg} title="" url={dsUrl} />
        </DialogContentText>
        <Button id="viewer_iframe_confirm" label="Confirm" onClick={onConfirm} style={{display: 'none'}} />
      </DialogContent>
    </Dialog>
  );
};

export default Agreement;
